import React, {
  useRef,
  useState,
} from 'react';

import {
  useClickAway,
} from 'web-hooks';
import {
  placeCaretAtEnd,
} from 'web-utils';

import {
  Icon,
  Button,
  Checkbox,
  Tooltip,
} from 'web-components';

import {
  Flex,
} from 'web-styled';
import {
  OpenedTooltip,
} from 'web-types';

import * as S from '../styled';

type Props = {
  item: {
    id: number;
    name: string;
    filetype: string;
    selected: boolean;
    document_file: {
      url: string;
    }
  }
  isFolder: boolean;
  openedTooltips: OpenedTooltip[];
  onSelect: { (): void };
  onClickItem: { (item: any): void };
  onChangeName: { (item: any, newName: string): void };
};

const Item = ({
  item,
  isFolder,
  openedTooltips,
  onSelect,
  onClickItem,
  onChangeName,
}: Props) => {
  const nameRef = useRef<HTMLDivElement>(null);
  const [editableName, setEditableName] = useState(false);

  const handleEdit = () => {
    const newName = nameRef.current?.textContent;
    if (newName) {
      onChangeName(item, newName);
    }
    setEditableName(false);
  };

  const ref = useClickAway(
    () => {
      setEditableName(false);
    },
    { disabled: !editableName },
  );

  const Name = editableName ? (
    <S.EditableWrapper
      ref={ref}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          handleEdit();
        }
      }}
    >
      <Flex
        width="16px"
        height="20px"
        align="center"
        justify="center"
      >
        {isFolder ? (
          <Icon
            type="far fa-folder"
            size={14}
          />
        ) : (
          <S.DocumentIcon />
        )}
      </Flex>
      <S.EditableName
        html={item.name}
        innerRef={nameRef}
      />
    </S.EditableWrapper>
  ) : (
    <S.Name
      to={isFolder ? `/documents_folder/${item.id}` : `/documents/${item.id}`}
      onClick={() => onClickItem(item)}
    >
      <Flex
        width="16px"
        height="20px"
        align="center"
        justify="center"
      >
        {isFolder ? (
          <Icon
            type="far fa-folder"
            size={14}
          />
        ) : (
          <S.DocumentIcon />
        )}
      </Flex>
      {item.name}
    </S.Name>
  );

  return (
    <S.Item>
      <Flex align="center" spacing={10}>
        <Checkbox
          checked={item.selected}
          onChange={onSelect}
        />
        {openedTooltips.some(el => el.key === item.name)
          ? (
            <Tooltip
              body={`Click ${item.name}`}
              positions={['right']}
              toggleMode
              initialState
            >
              {Name}
            </Tooltip>
          )
          : Name}
      </Flex>
      <Flex
        align="center"
        spacing={10}
        className="is_hover_only"
      >
        <Button
          ghost
          appearance="primary"
          onClick={() => {
            setEditableName(!editableName);
            if (!editableName) {
              setTimeout(() => {
                placeCaretAtEnd(nameRef.current);
              }, 0);
            }
          }}
        >
          Rename
        </Button>
        {!isFolder && (
          <Button
            as="a"
            rel="noopener noreferrer"
            ghost
            href={item.document_file?.url}
            target="_blank"
            appearance="primary"
          >
            View document
          </Button>
        )}
      </Flex>
    </S.Item>
  );
};

export default Item;
